export default {"src":"/_next/static/media/about_mobile.0996b611.svg","height":483,"width":430,"blurWidth":0,"blurHeight":0};